export default __webpack_public_path__ + "static/media/6osiha.96ac3fbe.webp";